import React from "react";
import "./App.css";
import Header from "./components/portfolio/Header";
import HeroSection from "./components/portfolio/HeroSection";
import AboutMe from "./components/portfolio/AboutMe";
import ExperienceTimeline from "./components/portfolio/ExperienceTimeline";
import SkillsGrid from "./components/portfolio/SkillsGrid";
import CertificationCard from "./components/portfolio/CertificationCard";
import EducationSection from "./components/portfolio/EducationSection";
import Footer from "./components/portfolio/Footer";

function App() {
  return (
    <div className="App bg-zinc-950 min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <AboutMe />
        <ExperienceTimeline />
        <SkillsGrid />
        <CertificationCard />
        <EducationSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
